import React from 'react';
import useReveal from '../hooks/useReveal';
import './ProblemSolution.css';

const PAIRS = [
  {
    problem: { title: 'Disengagement', body: 'Lectures and static diagrams don\u2019t hold attention the way hands-on practice does.' },
    solution: { title: 'Engagement', body: 'Learners drive the simulation themselves \u2014 every decision has a visible, immediate result.' },
  },
  {
    problem: { title: 'Imprecision', body: 'Without repeated practice, technique stays theoretical and mistakes get discovered in the field.' },
    solution: { title: 'Accuracy', body: 'A digital twin models substrate, humidity and spawn behaviour with real cultivation logic.' },
  },
  {
    problem: { title: 'Limited access', body: 'Labs, institutes and expert mentors aren\u2019t available to every aspiring farmer.' },
    solution: { title: 'Access', body: 'Runs on any device, anywhere \u2014 a full virtual lab without the infrastructure.' },
  },
];

export default function ProblemSolution() {
  const ref = useReveal();
  return (
    <section className="section problemsolution" id="why">
      <div className="container">
        <div className="reveal" ref={ref}>
          <p className="eyebrow">Why Inivayal exists</p>
          <h2 className="section-heading">
            Hands-on agricultural training is expensive, risky, and hard to scale. We built the
            practice ground instead.
          </h2>
        </div>

        <div className="problemsolution__table">
          <div className="problemsolution__col-head problemsolution__col-head--problem">The old way</div>
          <div className="problemsolution__col-head problemsolution__col-head--solution">The Inivayal way</div>

          {PAIRS.map((pair, i) => (
            <React.Fragment key={pair.problem.title}>
              <PsCard kind="problem" title={pair.problem.title} body={pair.problem.body} index={i} />
              <PsCard kind="solution" title={pair.solution.title} body={pair.solution.body} index={i} />
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}

function PsCard({ kind, title, body, index }) {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      className={`reveal ps-card ps-card--${kind}`}
      style={{ transitionDelay: `${index * 0.08}s` }}
    >
      <h3>{title}</h3>
      <p>{body}</p>
    </div>
  );
}
